import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type UserInvitationFailedAction = {
	type: 'USER_INVITATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): UserInvitationFailedAction => ({
	type: 'USER_INVITATION_FAILED',
	payload,
});
